import './em-page-gradient-positioner.scss';

export default {
  template: '<em-page-gradient class="em-page-gradient-positioner"></em-page-gradient>',
};
